var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LightBulb03Svg from './lightbulb-03.icon.svg';
export const LightBulb03Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LightBulb03Svg }));
_react_refresh_temp_1 = LightBulb03Icon;
$RefreshReg$(_react_refresh_temp_1, "LightBulb03Icon");
